<template>
    <div>
        <v-overlay :value="isLoading">
            <v-progress-circular indeterminate
                                 color="primary"
                                 :size="70"
                                 :width="7"></v-progress-circular>
        </v-overlay>
        <v-card class="mt-3">
            <v-row>
                <v-spacer></v-spacer>
                <v-btn class="text-xs mr-5" v-on:click="reloadItems()" color="primary">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>

            </v-row>
            <v-alert width="100%" class="pr-2 pl-2" v-if="errorMessage" type="error"> {{ errorMessage }}</v-alert>
            <v-alert width="100%" class="pr-2 pl-2" v-if="showSuccessMessage" type="success"> Successfully saved changes</v-alert>
            <v-row>
                <v-col>
                    <table>
                        <tr>
                            <td>
                                <v-text-field v-model="luItem.nextAffiliateId" label="Next Affiliate Id:" :disabled="true" />
                            </td>
                            <td>
                                <v-btn icon v-on:click="(e) => incrementId('affiliate')" color="primary">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </td>
                            <td class="pl-10">
                                <v-text-field v-model="luItem.nextKennelId" label="Next Kennel Id:" :disabled="true" />
                            </td>
                            <td>
                                <v-btn icon v-on:click="(e) => incrementId('kennel')" color="primary">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <v-text-field v-model="luItem.nextShowId" label="Next Show Id:" :disabled="true" />
                            </td>
                            <td>
                                <v-btn icon v-on:click="(e) => incrementId('show')" color="primary">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </td>
                            <td class="pl-10">
                                <v-text-field v-model="luItem.nextJudgeId" label="Next Judge Id:" :disabled="true" />
                            </td>
                            <td>
                                <v-btn icon v-on:click="(e) => incrementId('judge')" color="primary">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <v-text-field v-model="luItem.nextLitterId" label="Next Litter Id:" :disabled="true" />
                            </td>
                            <td>
                                <v-btn icon v-on:click="(e) => incrementId('litter')" color="primary">
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </td>
                            <td class="pl-7" colspan="2">
                                <div class="text-center mb-6">
                                    <div class="my-2">
                                        <v-btn small
                                               color="primary"
                                               v-on:click="cancel">
                                            Cancel
                                        </v-btn>
                                        <v-btn small class="ml-5"
                                               color="primary"
                                               v-on:click="save">
                                            Save
                                        </v-btn>
                                    </div>
                                </div>


                            </td>

                        </tr>
                    </table>
                </v-col>

            </v-row>

        </v-card>
    </div>
</template>

<script lang="ts">
import Vue from "vue";
import lookupsService from "@/services/admin/lookupsService";
import { NextIdsLookupInfo } from "@/types/admin/Lookup";

export default Vue.extend({
    name: "NextIdsMaintenance",
    data: function () {
        return {
            tab: null,
            luItem: {} as NextIdsLookupInfo,
            errorMessage: "",
            isLoading: false,
            showSuccessMessage: false,

        };
    },
    created: function () {
        this.reloadItems();
    },
    methods: {
        reloadItems() {
            this.$data.isLoading = true;
            lookupsService.getNextIdInfo().then((res: NextIdsLookupInfo) => {
                this.luItem = res;
                this.$data.isLoading = false;
            });
        },
        incrementId(nextId: string) {
            if (nextId == "affiliate") {
                this.luItem.nextAffiliateId++;
            }
            else if (nextId == "litter") {
                this.luItem.nextLitterId++;
            }
            else if (nextId == "kennel") {
                this.luItem.nextKennelId++;
            }
            else if (nextId == "show") {
                this.luItem.nextShowId++;
            } 
            else {
                this.luItem.nextJudgeId++;
            }

        },

        save() {
            this.errorMessage = "";
            this.showSuccessMessage = false;
            lookupsService.editNextIds(this.luItem).then((res: any) => {
                if (res.success) {
                    this.showSuccessMessage = true;
                }
                else {
                    this.errorMessage = "Unable to edit the Next Ids.";
                    return;
                }
            }).catch(
                () => {
                    this.errorMessage = "Unable to edit Next Ids.";
                });
            
        },
        cancel() {
            this.errorMessage = "";
            this.showSuccessMessage = false;
            this.reloadItems();
        },
        
    },
    
    
});
</script>
